export default __webpack_public_path__ + "static/media/quiz.6e25a018.png";